import Component from 'vue-class-component';

export const registerAsyncDataHook = {
  install() {
    Component.registerHooks([
      'fetch'
    ]);
  }
};



// WEBPACK FOOTER //
// ./src/vue-install/lite-register-vue-class-component-hook.ts